__turbopack_context__.v({
  "questionCurrency": "styles-module-scss-module__O5I5ba__questionCurrency",
});
